import { useState, useEffect } from 'react'
import { useThemeStore } from '../stores/themeStore'

export function useChartColors() {
    // Subscribe to theme and colorMode so this hook re-runs on theme changes
    const theme = useThemeStore(s => s.theme)
    const colorMode = useThemeStore(s => s.colorMode)

    const [colors, setColors] = useState({
        primary: 'rgba(139, 92, 246, 0.7)',
        primarySubtle: 'rgba(139, 92, 246, 0.25)',
        secondary: 'rgba(56, 189, 248, 0.9)',
        comp1: 'rgba(100, 116, 139, 0.6)',
        comp2: 'rgba(251, 146, 60, 0.6)',
        donut: [
            '#8b5cf6', '#3b82f6', '#10b981', '#f59e0b', '#ef4444',
            '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'
        ]
    })

    useEffect(() => {
        // Read the computed styles from the DOM.
        // We use requestAnimationFrame to guarantee the DOM updates (via data-theme attribute)
        // have occurred BEFORE we compute the style.
        requestAnimationFrame(() => {
            const style = getComputedStyle(document.documentElement)

            const getVar = (name: string, fallback: string) => style.getPropertyValue(name).trim() || fallback

            setColors({
                primary: getVar('--chart-primary', 'rgba(139, 92, 246, 0.7)'),
                primarySubtle: getVar('--chart-primary-subtle', 'rgba(139, 92, 246, 0.25)'),
                secondary: getVar('--chart-secondary', 'rgba(56, 189, 248, 0.9)'),
                comp1: getVar('--chart-comp-1', 'rgba(100, 116, 139, 0.6)'),
                comp2: getVar('--chart-comp-2', 'rgba(251, 146, 60, 0.6)'),
                donut: Array.from({ length: 10 }, (_, i) => getVar(`--chart-donut-${i + 1}`, '#8b5cf6'))
            })
        })
    }, [theme, colorMode])

    return colors
}
